import fetch from '@api/fetchers';
import {
  BATCH_CONTENT_TYPE_ID,
  FETCH_STORE_SYLLABUS_VALUES
} from '@cont/Batch/utils';
import { HOST_TYPE, getCMSHost, getHost } from '@utils/api-helper/host';

const defaultHost = getHost();
const CMSHost = getCMSHost();
const backendHost = getHost(HOST_TYPE.BACKEND_API_HOST);

const defaultTopicsLevel = 30;
const defaultTestSeriesLimit = 100;

export const fetchBatchData = (batchUID) =>
  fetch(`${defaultHost}v3/batch/${batchUID}/details/`);

export const fetchBatchTopicFeed = (batchUID) =>
  fetch(
    `${defaultHost}v1/syllabus/playlist/home/feed?product_content_type_id=${BATCH_CONTENT_TYPE_ID}&product_uid=${batchUID}`
  );

export const fetchBatchConceptFeed = (batchUID, topicUID) =>
  fetch(
    `${defaultHost}v1/syllabus/playlist/concept/feed?product_content_type_id=${BATCH_CONTENT_TYPE_ID}&product_uid=${batchUID}&topic_uid=${topicUID}`
  );

// &product_uid=JAP8NU0U&topic_uid=BQILO`

export const fetchBatchSkuData = (
  batchUID,
  goalUid,
  contentTypeId = BATCH_CONTENT_TYPE_ID
) => {
  return fetch(
    `${backendHost}v1/subscriptions/user/store_skus/?content_type_id=${contentTypeId}&object_uid=${batchUID}&goal_uid=${goalUid}&send_extra_details=True&centre_sub_required=True`
  );
};

export const fetchStorePlaylistFeed = (batchUID) => {
  return fetch(
    `${defaultHost}v1/syllabus/playlist/home/feed?product_content_type_id=${BATCH_CONTENT_TYPE_ID}&product_uid=${batchUID}`
  );
};

export const fetchStorePlaylistTestFeed = ({ batchUID, offset }) => {
  return fetch(
    `${defaultHost}v1/batch/${batchUID}/completed_tests/?limit=${FETCH_STORE_SYLLABUS_VALUES.LIMIT}&offset=${offset}`
  );
};

export const fetchTopicsCovered = (batchUID, level = defaultTopicsLevel) =>
  fetch(`${defaultHost}v1/batch/${batchUID}/topics/?level=${level}`);

export const fetchTestSeries = (batchUID, limit = defaultTestSeriesLimit) =>
  fetch(`${defaultHost}v1/batch/${batchUID}/test_series/?limit=${limit}`);

export const fetchSchedule = (batchUID) => {
  const date = new Date();
  const timezoneDifference = date.getTimezoneOffset() * -1;
  const epoch = Math.floor(date.getTime() / 1000);
  return fetch(
    `${defaultHost}v1/batch/${batchUID}/schedule/?offset=${epoch}&timezone_difference=${timezoneDifference}&limit=6`
  );
};

export const fetchTrialClasses = (batchUID) =>
  fetch(`${defaultHost}v1/batch/${batchUID}/trial_classes/`);

export const fetchBatchFaq = (key = 'batchesfaq') =>
  fetch(`${CMSHost}subscription-faqs/${key}/`);

export const fetchBatchFeedbacks = (goalUID) =>
  fetch(
    `${defaultHost}v1/uplus/feedbacks/?limit=4&offset=0&goal_uid=${goalUID}`
  );

export const fetchBatchDemoClasses = (batchUID) =>
  fetch(`${defaultHost}v2/batch/${batchUID}/demo-class`);

export const fetchCourseDemoClasses = (courseUID) =>
  fetch(`${defaultHost}v1/uplus/${courseUID}/demo-class`);

export const submitFeedback = ({
  feedbackUID,
  otherReason,
  choiceUID,
  batchUID,
  options
}) =>
  fetch(`v1/feedback/${feedbackUID}/response/`, {
    requestType: 'POST',
    body: {
      others: otherReason,
      choice_id: choiceUID,
      object_id: batchUID,
      options
    }
  });

export const fetchEducatorBatches = (
  userName,
  filters = {
    limit: 12,
    offset: 0,
    type: 'latest'
  }
) => {
  const endpoint = `${defaultHost}sheldon/v1/list/batch?username=${userName.toLowerCase()}&limit=${
    filters.limit
  }&offset=${filters.offset}`;
  return fetch(endpoint);
};
